import React from "react";
import Banner from "../../../assets/images/banner.jpeg";
import BLOCHALANGE from "../../../assets/images/BLOCHALANGE3.jpg";
import SecImage from "../../../assets/images/sec.jpeg";
import { Link } from "react-router-dom";
import ImageComponent from "../../../components/image/ImageComponent";
import { Accordion, AccordionTab } from "primereact/accordion";
import { routes } from "../../../routes";

const Landing = () => {

  return (
    <div className="landing_container">
      <section className="banner_container">
        <div className="box_container">
          <div className="banner_wraper">
            <h1>Simplifiez votre processus d'admission à l'école229</h1>
            <p>
              Inscrivez-vous facilement et passez notre test d'admission bien
              élaboré en ligne pour candidater à votre parcours scolaire.
              Admission Ecole229 vise à simplifier et à gérer efficacement le
              processus d'admission ou de candidature à l'ecole229.
            </p>
            <div className="cta_container">
              <button className="cta_btn">
                <Link to={routes.application.application}>
                  Rejoindre l'école229
                </Link>
              </button>
              <button className="cta_btn">
                <Link to={routes.formation}>Découvrir nos parcours</Link>
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="section_container">
        <div className="box_container">
          <div className="section_wraper">
            <div className="section_content">
              <h2 className="section_title">
                Simplifiez votre admission chez nous avec notre plateforme en
                ligne
              </h2>
              <p>
                Inscrivez-vous facilement et passez notre test d'admission bien
                élaboré en ligne pour candidater à votre parcours scolaire.
              </p>
              <div className="section_description">
                <li>
                  <span className="pi pi-box"></span>
                  <span>Inscription simple et rapide pour les étudiants</span>
                </li>
                <li>
                  <span className="pi pi-box"></span>{" "}
                  <span>
                    Test d'admission bien élaboré pour évaluer vos compétences
                  </span>
                </li>
                <li>
                  <span className="pi pi-box"></span>
                  <span>
                    Gestion transparente du processus d'admission pour les
                    administrateurs
                  </span>
                </li>
              </div>
            </div>
            <div className="section_image">
              <ImageComponent src={SecImage} alt="Image" />
            </div>
          </div>
        </div>
      </section>
      <section className="section_container ">
        <div className="box_container">
          <div className="section_wraper reverse">
            <div className="section_content">
              <div className="section_steper">
                <h2 className="section_title">Suivi de candidature</h2>
                <p>
                  Les administrateurs peuvent facilement suivre l'état des
                  candidatures et prendre les mesures nécessaires.
                </p>
              </div>
              <div className="section_steper">
                <h2 className="section_title">Gestion des admissions</h2>
                <p>
                  Les administrateurs peuvent gérer efficacement le processus
                  d'admission, de l'étude des dossiers à l'admission finale.
                </p>
              </div>
              <div className="section_steper">
                <h2 className="section_title">Expérience conviviale</h2>
                <p>
                  Admission Ecole229 offre une expérience rationalisée, sans
                  pression et facile à utiliser.
                </p>
              </div>
            </div>
            <div className="section_image">
              <ImageComponent src={Banner} alt="Image" />
            </div>
          </div>
        </div>
      </section>
      <section className="section_container">
        <div className="box_container">
          <div className="section_wraper">
            <div className="section_content">
              <h2 className="section_title">Inscrivez-vous dès maintenant</h2>
              <p>
                Commencez votre processus d'admission ou de candidature en
                créant un compte
              </p>
              <div className="section_description">
                <div className="cta_container">
                  <button className="cta_btn">
                    <Link>Rejoindre l'école229</Link>
                  </button>
                  <button className="cta_btn">
                    <Link>Découvrir nos parcours</Link>
                  </button>
                </div>
              </div>
            </div>
            <div className="section_image">
              <ImageComponent src={BLOCHALANGE} alt="Image" />
            </div>
          </div>
        </div>
      </section>
      <section className="section_container">
        <div className="box_container">
          <div className="faq_wraper">
            <h2 className="section_title">FAQs</h2>
            <p>
              Trouvez ici les réponses aux questions fréquemment posées sur le
              processus d'admission.
            </p>
            <Accordion className="faq_accordion">
              <AccordionTab
                className="faq"
                headerStyle={{
                  marginTop: "25px",
                }}
                header={
                  <div className="faq_header">
                    <span className="font-bold">
                      Comment s'inscrire à l'école?
                    </span>
                  </div>
                }
              >
                <p className="m-0">
                  Pour vous inscrire à notre école, vous devez remplir le
                  formulaire d'inscription en ligne et passer notre test
                  d'admission.
                </p>
              </AccordionTab>
              <AccordionTab
                className="faq"
                headerStyle={{
                  marginTop: "25px",
                }}
                header={
                  <div className="faq_header">
                    <span className="font-bold">
                      Quels sont les critères d'admission?
                    </span>
                  </div>
                }
              >
                <p className="m-0">
                  Les critères d'admission varient en fonction du parcours
                  choisi. Mais retenez que le plus important est votre
                  motivation et votre projet professionnel.
                </p>
              </AccordionTab>
              <AccordionTab
                className="faq"
                headerStyle={{
                  marginTop: "25px",
                }}
                header={
                  <div className="faq_header">
                    <span className="font-bold">
                      Quand saurai-je si j'ai été admis?
                    </span>
                  </div>
                }
              >
                <p className="m-0">
                  Le processus de décision d'admission peut prendre quelques
                  semaines. Vous serez informé par e-mail dès que la décision
                  sera prise.
                </p>
              </AccordionTab>
              <AccordionTab
                className="faq"
                headerStyle={{
                  marginTop: "25px",
                }}
                header={
                  <div className="faq_header">
                    <span className="font-bold">
                      Quels sont les frais de scolarité?
                    </span>
                  </div>
                }
              >
                <p className="m-0">
                  Les frais de scolarité varient en fonction du parcours choisi.
                  Veuillez consulter notre site Web ou nous contacter pour
                  obtenir des informations détaillées.
                </p>
              </AccordionTab>
              <AccordionTab
                className="faq"
                headerStyle={{
                  marginTop: "25px",
                }}
                header={
                  <div className="faq_header">
                    <span className="font-bold">
                      Y a-t-il des bourses disponibles?
                    </span>
                  </div>
                }
              >
                <p className="m-0">
                  Oui, nous offrons des bourses aux étudiants méritants.
                  Veuillez consulter notre site Web ou nous contacter pour plus
                  d'informations.
                </p>
              </AccordionTab>
            </Accordion>
          </div>
          <div className="section_container">
            <div className="box_container">
              <div
                className="section_wraper"
                style={{
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  gap: "2px",
                }}
              >
                <h2 className="section_title" style={{}}>
                  Des questions supplémentaires?
                </h2>
                <p style={{ marginBottom: "35px" }}>
                  Contactez-nous pour plus d'informations.
                </p>
                <div className="contact_wraper">
                  <div className="contact_box">
                    <div className="contact_head">
                      <span className="pi pi-envelope contact_icon"></span>
                      <div className="contact_title">Email</div>
                    </div>
                    <div className="contact_ctn">
                      <p>
                        Envoyez-nous un email et nous vous répondrons dans les
                        plus brefs délais.
                      </p>
                      <a
                        href="mailto:contact@ecole229.bj"
                        className="contact_link"
                      >
                        contact@ecole229.bj
                      </a>
                    </div>
                  </div>
                  <div className="contact_box">
                    <div className="contact_head">
                      <span className="pi pi-phone contact_icon"></span>
                      <div className="contact_title">Téléphone</div>
                    </div>
                    <div className="contact_ctn">
                      <p>Appelez-nous pour obtenir une assistance immédiate.</p>
                      <a href="tel:+22952124112" className="contact_link">
                        +22952124112
                      </a>
                    </div>
                  </div>
                  <div className="contact_box">
                    <div className="contact_head">
                      <span className="pi pi-map-marker contact_icon"></span>
                      <div className="contact_title">Siège</div>
                    </div>
                    <div className="contact_ctn">
                      <p>Venez nous rendre visite à notre siège principal.</p>
                      <span className="contact_link">
                        Cotonou, zogbohouê, von du collège Houphouet Boigny
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Landing;
